module.exports = __webpack_public_path__ + "img/dialog_image_S205P_WX1.ded7f273.png";